import React, { Fragment, useEffect, useState } from 'react';
import { Card, Col, Row } from 'reactstrap';
import { H6, P, UL, LI } from '../../../AbstractElements';
import { Admin } from '../../../Constant';
import { useNavigate } from 'react-router';
import axios from 'axios';
import './Gallery.css';
import { ServerPath } from '../../../Constant';
import Swal from 'sweetalert2';

const Gallery = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${ServerPath}/blog`);
        console.log(response);
        const actualData = response?.data?.data;
        console.log(actualData);
        setData(actualData);
      } catch (error) {
        console.log("Error fetching data :", error);
      }
    };
    fetchData();
  }, []);

  const handleClick = async (BlogDetails) => {
    try {
      navigate(`${process.env.PUBLIC_URL}/blog/blogSingle`, { state: { BlogDetails } });
    } catch (error) {
      console.log("err = ", error);
    }
  };

  const getMonth = (dateString) => {
    return new Date(dateString).getMonth() + 1;
  };

  const getDay = (dateString) => {
    return new Date(dateString).getDate();
  };

  const handleDeleteID = async (blogId, event) => {
    event.preventDefault();

    try {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        customClass: {
          container: 'swal2-container'
        }
      });

      if (result.isConfirmed) {
        await axios.delete(`${ServerPath}/blog/${blogId}`);
        setData(prevData => prevData.filter(data => data.blog_id !== blogId));

        Swal.fire(
          'Deleted!',
          'Your entry has been deleted.',
          'success'
        );
      }
    } catch (error) {
      console.error('Error deleting user:', error);

      Swal.fire(
        'Error!',
        'There was an error deleting your entry.',
        'error'
      );
    }
  };

  return (
    <Fragment>
      <Row className="g-3">
        {data.map((item) => (
          <Col sm="6" xl="3" className='box-col-6 des-xl-50' key={item.blog_id}>
            <Card className="blog-card">
              <div className="blog-box blog-grid">
                <div className="blog-wrraper w-100">
                  <img
                    className='img-fluid top-radius-blog w-100'
                    src={item.image}
                    alt=''
                    onClick={() => handleClick(item)}
                  />
                </div>
                <div className="blog-details-second">
                  <div className="blog-post-date">
                    <span className="blg-month">{getMonth(item.blog_date)}</span>
                    <span className="blg-date">{getDay(item.blog_date)}</span>
                  </div>
                  <H6 attrH6={{ className: 'blog-bottom-details' }}>
                    <b>{item.title}</b>
                  </H6>
                  <P>{item.content}</P>
                  <div className="detail-footer">
                    <UL attrUL={{ className: 'social-list simple-list flex-row' }}>
                      <LI>
                        <i className="fa fa-user-o"></i>{Admin}
                      </LI>
                      <LI>
                        <i className="fa fa-comments-o"></i>0
                      </LI>
                      <LI>
                        <i className="fa fa-thumbs-o-up"></i>0 like
                      </LI>
                      <LI>
                        <button className="delete-button" onClick={(e) => handleDeleteID(item.blog_id, e)}>
                          <i className="icon-trash"></i>
                        </button>
                      </LI>
                    </UL>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </Fragment>
  );
};

export default Gallery;
